import React from "react";
import PropTypes from 'prop-types';

const CustomCheckbox = (props) => {
    const { isChecked, label, disabled, handleCheck, className, disableWrapper } = props;
    let wrapper = '';
    if (!disableWrapper) {
        wrapper = isChecked ? "checked-wrapper " : "unchecked-wrapper "
    }

    const handleOnClick = () => {
        if (!disabled) {
            handleCheck();
        }
    }
    return (
        <label className={`check-wrapper ${wrapper} ${disabled ? "disabled-label" : ""} ${className}`}>
            <div className={`checkbox-container`}>
                <input type="checkbox"
                    defaultChecked={isChecked} onChange={handleOnClick} />

                {!disabled && <span className={`checkmark ${isChecked ? "checked" : ''}`} />}
                <div className="label">
                    <span>{label}</span>
                </div>
            </div>
        </label>
    );
}

CustomCheckbox.defaultProps = {
    disabled: false
}

CustomCheckbox.propTypes = {
    disabled: PropTypes.bool,
}
export default CustomCheckbox;